import { Validators } from "@angular/forms";
import { debounceTime, filter } from 'rxjs';
import { UserEmailControls, UserEmailForm } from "../form.controls";
import { FormFactory } from "../form.factory";
import { UserEmail } from "../form.resources";

export function getUserEmailForm(this: FormFactory): UserEmailForm {
  const data = this.data as UserEmail | undefined;

  const form = this.fb.group<UserEmailControls>({
    id: this.fb.control(data?.id || new Date().valueOf().toString(), { nonNullable: true }),
    email: this.fb.control(data?.email ?? '', { validators: [Validators.required, Validators.email], nonNullable: true }),
    terms_of_service: this.fb.control(data?.terms_of_service ?? false, { validators: Validators.requiredTrue, nonNullable: true }),
    password: this.fb.control(
      { value: data?.password ?? '', disabled: true },
      { validators: Validators.required, nonNullable: true },
    ),
  });

  form.statusChanges
    .pipe(
      debounceTime(1000),
      filter(() => form.valid),
    )
    .subscribe({
      next: async () => {
        try {
          await this.formService.updateGuestUserEmail(form.getRawValue());
        } catch (error) {
          console.error('Error while updating guest user email', error);
        }
      }
    });

  return form;
}
